var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563D7C",
    d: "M0 222.991C0 241.223 14.779 256 33.009 256H222.99c18.233 0 33.01-14.779 33.01-33.009V33.01C256 14.777 241.221 0 222.991 0H33.01C14.777 0 0 14.779 0 33.009V222.99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M106.158 113.238V76.985h31.911q4.56 0 8.792.76 4.233.759 7.49 2.713 3.255 1.954 5.21 5.427 1.953 3.474 1.954 8.9 0 9.77-5.862 14.111-5.86 4.342-14.979 4.342zM72.075 50.5v155h75.112q10.42 0 20.298-2.605t17.584-8.032 12.265-14.002q4.56-8.576 4.559-20.298 0-14.545-7.055-24.856-7.056-10.312-21.384-14.437 10.42-4.993 15.74-12.808 5.318-7.814 5.318-19.538 0-10.854-3.582-18.235-3.582-7.38-10.095-11.831-6.512-4.45-15.63-6.404-9.117-1.954-20.189-1.954zm34.083 128.515v-42.549h37.121q11.072 0 17.802 5.102 6.73 5.101 6.73 17.041 0 6.079-2.063 9.986-2.062 3.908-5.536 6.187t-8.032 3.257q-4.56.976-9.552.976z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.47f243b3749e3eebcd38cbd8d5cdce76.svg";
export { ForwardRef as ReactComponent };